import React from 'react';
import { FaStar } from 'react-icons/fa';

const RATING_LABELS = ['sehr schlecht', 'schlecht', 'okay', 'gut', 'sehr gut'];

interface StarRatingProps {
    label: string;
    value: number | null;
    onChange: (value: number | null) => void;
}

const StarRating: React.FC<StarRatingProps> = ({ label, value, onChange }) => (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
        <span className="font-medium text-textColor">{label}</span>
        <div className="flex items-center gap-2">
            <div role="radiogroup" aria-label={label} className="flex">
                {RATING_LABELS.map((ratingLabel, idx) => {
                    const rating = idx + 1;
                    const filled = value !== null && rating <= value;
                    return (
                        <button
                            key={rating}
                            type="button"
                            role="radio"
                            aria-checked={value === rating}
                            aria-label={`${rating} von 5 Sternen – ${ratingLabel}`}
                            title={ratingLabel}
                            onClick={() => onChange(value === rating ? null : rating)}
                            className="p-1 transition hover:scale-110"
                        >
                            <FaStar className={`h-7 w-7 ${filled ? 'text-primary' : 'text-gray-300'}`} aria-hidden="true" />
                        </button>
                    );
                })}
            </div>
            <span className="w-24 text-sm text-gray-600">{value ? RATING_LABELS[value - 1] : ''}</span>
        </div>
    </div>
);

export default StarRating;
